import store from '@/state/store';
import projectSlice from '@/state/project.slice';
import authenticationSlice from '@/state/authentication.slice';
import { Event, Profile } from '@bimdata/definitions/dto';
import { AccessLevel } from '@bimdata/definitions/const';
import { ProjectData } from '@/state/types/project-data';

export default async function (event: Event, profile: Profile, currentProject: ProjectData | null) {
  const { projectCode, userId, invitationId, access } = event.data;
  if (invitationId) {
    if (userId === profile.id) {
      store.dispatch(
        authenticationSlice.actions.setInvitationAccessLevel({
          id: invitationId,
          access,
        })
      );
    } else {
      store.dispatch(
        projectSlice.actions.setInvitationsAccessLevel({
          code: projectCode,
          ids: [invitationId],
          access,
        })
      );
    }
    return;
  }

  if (userId === profile.id) {
    store.dispatch(
      projectSlice.actions.setAccess({
        code: projectCode,
        access,
      })
    );
  } else if (access == AccessLevel.OWNER && currentProject?.access == AccessLevel.OWNER) {
    store.dispatch(
      projectSlice.actions.setAccess({
        code: projectCode,
        access: AccessLevel.ADMIN,
      })
    );
  }

  if (access == AccessLevel.OWNER) {
    const ownerParticipant = currentProject?.participants?.find(({ access }) => access === AccessLevel.OWNER);
    if (ownerParticipant) {
      store.dispatch(
        projectSlice.actions.setParticipantsAccessLevel({
          code: projectCode,
          ids: [ownerParticipant.user.id],
          access: AccessLevel.ADMIN,
        })
      );
    }
  }

  store.dispatch(
    projectSlice.actions.setParticipantsAccessLevel({
      code: projectCode,
      ids: [userId],
      access,
    })
  );
};
